import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { withMediaListener } from '@xingternal/util';
import * as Styled from './menu.styles';
const Menu = ({ children, dimmerTitle, isInFlow, isStatic, matchedMedia, offset = 0, onOutsideClick, show = false, triggerRef, ...props }) => {
    const isHandheld = matchedMedia === 'handheld';
    return (_jsx(React.Fragment, { children: isHandheld ? (_jsx(Styled.BottomSheet, { dimmerTitle: dimmerTitle, onOutsideClick: onOutsideClick, show: show, ...props, children: children })) : (_jsx(Styled.PopOver, { isInFlow: isInFlow, isStatic: isStatic, offset: offset, onOutsideClick: onOutsideClick, show: show, triggerRef: triggerRef, ...props, children: children })) }));
};
export default withMediaListener(Menu);
//# sourceMappingURL=menu.js.map